// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import OpenMaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/open-maintenance-plan';
import PlanNameDropDown from './plan-name-dropdown';
import {getFieldClassName} from '../../../shared/services/claim-shared-helper';
import {translate} from '../../../../shared/services/translation-service';

const LabeledPlanNameDropDown = ({className, errorMessage, highlightClass, isValid = true, label, selectedValue, vsrMessage, ...props}) =>
    <LabeledFormInput
        className={getFieldClassName(className, isValid, highlightClass)}
        label={label}
    >
        <EditableField
            isEditable={props.isEditable}
            value={selectedValue.planDescription}
        >
            <PlanNameDropDown
                {...props}
                className={className}
                value={selectedValue.planName}
            />
        </EditableField>
        {
            !isValid && errorMessage &&
                <span className='error-message'>
                    <FormattedMessage id={errorMessage}/>
                </span>
        }
        {
            vsrMessage && <span className='vsr-message'>{`${vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
        }
    </LabeledFormInput>;

LabeledPlanNameDropDown.displayName = 'LabeledPlanNameDropDown';
LabeledPlanNameDropDown.propTypes = {
    className: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(OpenMaintenancePlan)).isRequired,
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.instanceOf(OpenMaintenancePlan).isRequired,
    vsrMessage: PropTypes.string
};

export default LabeledPlanNameDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-plan-name-dropdown.js